<template>
  <div class="row search-filter-category">
    <div class="col-12">
      <a v-b-toggle="`collapse-contact-filter-facet`" class="facet-collapse-icon c-pointer">
        <font-awesome-icon
          class="when-opened "
          icon='caret-down'
          size="lg" />
        <font-awesome-icon
          class="when-closed fa-w-10"
          icon='caret-right'
          size="lg" />
      </a>
      <span class="font-weight-bold ">Contact Filters</span>
      <b-collapse :id="`collapse-contact-filter-facet`"
        class="row"
        :visible="initialSearchCategoryStates['contact']"
      >
        <div class="search-filter-list">
          <div class="sub-search-type-filter search-panel-items col-md-12">Contact Is</div>
          <div class="search-panel-items">
            <div class="row"
                 v-for="contact in contacts"
                 :key="contact.id">
              <div class="col-md-10">{{ contact | contactName }}
              </div>
              <div class="col-md-2">
                <a class="text-danger mr-2 mb-2"
                   @click="deleteContactEntry(contact)"
                   :aria-label="deleteContactEntry">
                  <font-awesome-icon icon="trash-alt" fixed-width />
                </a>
              </div>
            </div>
          </div>
          <div class="search-panel-items sub-search-type-filter col-md-12">
            <SearchContactsModal
               :modalId="'advancedContactSearchForContact'"
               @set-contact="addToContacts"
               :disableExisting="true"
               :searchButtonText="'Select Contact'"
               />
          </div>
          <div class="sub-search-type-filter search-panel-items col-md-12">Contact Is Not</div>
          <div class="search-panel-items">
            <div class="row"
                 v-for="contact in notContacts"
                 :key="contact.id">
              <div class="col-md-10">{{ contact | contactName }}</div>
              <div class="col-md-2 pl-md-0 d-flex flex-row-reverse
              flex-md-column justify-content-between justify-content-md-start">
                <div class="d-flex justify-content-end">
                  <a class="text-danger mr-2 mb-2"
                     @click="deleteNotContactEntry(contact)"
                     :aria-label="deleteNotContactEntry">
                    <font-awesome-icon icon="trash-alt" fixed-width />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="search-panel-items sub-search-type-filter col-md-12">
            <SearchContactsModal
               :modalId="'advancedContactSearchForNotContact'"
               @set-contact="addToNotContacts"
               :disableExisting="true"
               :searchButtonText="'Select Contact'"
               />
          </div>
          <div class="sub-search-type-filter search-panel-items col-md-12">With Role(s)</div>
          <div v-if="contacts.length === 0 && notContacts.length === 0"
               class="search-panel-items">
            Select Contacts above to select roles.
          </div>
          <template v-else>
            <div class="loading col-lg-5" v-if="rolesLoading">
              Loading...
            </div>
            <b-form-checkbox-group
              v-if="!rolesLoading"
              v-model="selectedRoles"
              class="scrollable-section search-panel-items search-filter-list"
              name="roles"
            >
              <b-form-checkbox
                v-for="role in contactRoles"
                :key="role.id"
                :value="role.id"
                class="col-md-12 noselect">
                {{ role.name }}
              </b-form-checkbox>
            </b-form-checkbox-group>
          </template>
        </div>
      </b-collapse>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import SearchContactsModal from '@/components/contacts/SearchContactsModal.vue';
import { LookupModules } from '@/store/moduleConfig';

export default {
  name: 'ContactSearchFacet',
  components: {
    SearchContactsModal,
  },
  computed: {
    ...mapState('Search', {
      initialSearchCategoryStates: state => state.initialSearchCategoryStates,
    }),
    ...mapState(LookupModules.INSTRUMENT_ROLES.namespace, {
      contactRoles: state => state.options,
      rolesLoading: state => state.loading,
    }),
    ...mapGetters(LookupModules.INSTRUMENT_ROLES.namespace, {
      contactRoles: 'getActiveOptions',
    }),
    contacts: {
      get() {
        return this.$store.state.Search.selectedSearchFacets.contacts;
      },
      set(value) {
        this.setFacet('contacts', value);
      },
    },
    notContacts: {
      get() {
        return this.$store.state.Search.selectedSearchFacets.notContacts;
      },
      set(value) {
        this.setFacet('notContacts', value);
      },
    },
    selectedRoles: {
      get() {
        return this.getOption('roles');
      },
      set(value) {
        this.setFacet('roles', value);
      },
    },
  },
  mounted() {
    this.$store.dispatch(`${LookupModules.INSTRUMENT_EVENT_TYPES.namespace}/fetchOptions`,
      LookupModules.INSTRUMENT_EVENT_TYPES.url);
    this.contacts = this.$store.state.Search.selectedSearchFacets
      ? this.$store.state.Search.selectedSearchFacets.contacts : [];
    this.notContacts = this.$store.state.Search.selectedSearchFacets
      ? this.$store.state.Search.selectedSearchFacets.notContacts : [];
  },
  methods: {
    addToContacts(contact) {
      this.contacts.push(contact);
    },
    addToNotContacts(contact) {
      this.notContacts.push(contact);
      this.setFacet('notContacts', this.notContacts.map(ct => ct.crmId));
    },
    getOption(fieldName) {
      return this.$store.state.Search.selectedSearchFacets[fieldName];
    },
    setFacet(fieldName, value) {
      this.$store.dispatch(
        'Search/updateSearchFacet',
        {
          type: fieldName,
          values: value,
        },
      );
    },
    deleteContactEntry(contact) {
      this.contacts.splice(this.contacts.indexOf(contact), 1);
    },
    deleteNotContactEntry(contact) {
      this.notContacts.splice(this.contacts.indexOf(contact), 1);
    },
  },
};
</script>
